import React from "react";
import { useTranslation } from "react-i18next";
import { useUpdateTimesheetDeadline } from "@planzone/view-models";
import { DateTimeInput } from "@common/dateTimeInput";
import { Props } from "./types";
import styles from "./styles.scss";

function TimesheetDeadline({ planzone }: Props) {
  const { t } = useTranslation();
  const { updateTimesheetDeadline } = useUpdateTimesheetDeadline(planzone);

  const [deadline, setDeadline] = React.useState<string>(
    planzone.timesheetDeadline || "",
  );

  React.useEffect(() => {
    setDeadline(planzone.timesheetDeadline || "");
  }, []);

  return (
    <div className={styles.timesheetDeadline}>
      <p className={styles.description}>
        {t("planzoneParametersPage.timesheetDeadline.description")}
      </p>
      <div className={styles.content}>
        <DateTimeInput
          dateTime={deadline}
          placeholder={t(
            "planzoneParametersPage.timesheetDeadline.placeholder",
          )}
          input={(dateTime) => {
            setDeadline(dateTime);
            updateTimesheetDeadline({
              planzone,
              timesheetDeadline: dateTime || null,
            });
          }}
          clear={() => {
            setDeadline("");
            updateTimesheetDeadline({ planzone, timesheetDeadline: null });
          }}
          showCalendarIcon={true}
        />
      </div>
    </div>
  );
}

export { TimesheetDeadline };
